export default __webpack_public_path__ + "client03.jpg";